module.exports = __webpack_public_path__ + "img/B3.7c3a4ca8.png";